import React, { useEffect, useState } from 'react';
import { getClubEvents,postEvent,uploadImage,update_event,deleteEvent, createChampion, getChampion, updateChampion, deleteChampion, getRiders } from '../../../Utils/apiServices';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid as MuiGrid,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import TrophyIcon from '@mui/icons-material/EmojiEvents';
import ConfirmDialog from '../../../Components/ConfirmDialog';

function parseSessionalPass(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0) return false;
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0' || v === '') return false;
  }
  return false;
}

function getSessionalPassFromEvent(event) {
  if (!event || typeof event !== 'object') return false;
  const raw =
    event.as_sessional_pass ??
    event.as_session_pass ??
    event.asSessionalPass;
  return parseSessionalPass(raw);
}

const ClubDetails = () => {
    const { id,champion_available } = useParams();
    console.log(champion_available,'champion_available');
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        event_name: '',
        event_date: '',
        event_video: '',
        event_video_url: '',
        image: '',
        club_id: id,
        as_sessional_pass: false
    });
    const [isUploading, setIsUploading] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);
    
    // Champions state
    const [champions, setChampions] = useState([]);
    const [riders, setRiders] = useState([]);
    const [isChampionModalOpen, setIsChampionModalOpen] = useState(false);
    const [championFormData, setChampionFormData] = useState({
        riderid: '',
        clubid: id,
        points: '',
        type: ''
    });
    const [editingChampion, setEditingChampion] = useState(null);

    const [deleteTarget, setDeleteTarget] = useState({
        open: false,
        kind: null,
        event: null,
        championId: null,
    });
    const [deleteLoading, setDeleteLoading] = useState(false);

    const getEmptyEventForm = () => ({
        event_name: '',
        event_date: '',
        event_video: '',
        event_video_url: '',
        image: '',
        club_id: id,
        as_sessional_pass: false
    });

    useEffect(() => {
        getClubEvents(id).then((response) => {
            setEvents(response.data.data);
        });
        fetchChampions();
        fetchRiders();
    }, []);

    const fetchChampions = async () => {
        try {
            const response = await getChampion(id);
            setChampions(response.data.data || []);
        } catch (error) {
            console.error('Error fetching champions:', error);
        }
    };

    const fetchRiders = async () => {
        try {
            const response = await getRiders();
            setRiders(response.data.data || []);
        } catch (error) {
            console.error('Error fetching riders:', error);
        }
    };

    const handleFileUpload = async (e, type) => {
        setIsUploading(true);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append(type === 'event_video' ? 'video' : 'file', file);
        try {
            const response = await uploadImage(formData);
            setFormData(prev => ({
                ...prev,
                [type]: response.data.file[0]
            }));
        } catch (error) {
            console.error('Upload failed:', error);
        }
        setIsUploading(false);
    };

    const handleEditClick = (event, e) => {
        e.stopPropagation();
        setEditingEvent(event);
        setFormData({
            id: event.id,
            event_name: event.event_name,
            event_date: event.event_date,
            event_video: event.event_video,
            event_video_url: '',
            image: event.image,
            club_id: id,
            as_sessional_pass: getSessionalPassFromEvent(event)
        });
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = {
                ...formData,
                event_video: formData.event_video_url || formData.event_video,
                as_sessional_pass: parseSessionalPass(formData.as_sessional_pass)
            };
            
            if (editingEvent) {
                await update_event(submitData);
            } else {
                await postEvent(submitData);
            }

            const response = await getClubEvents(id);
            setEvents(response.data.data);
            setIsModalOpen(false);
            setEditingEvent(null);
            setFormData(getEmptyEventForm());
        } catch (error) {
            console.error('Failed to save event:', error);
        }
    };

    const openDeleteEventConfirm = (event, e) => {
        e.stopPropagation();
        setDeleteTarget({
            open: true,
            kind: 'event',
            event,
            championId: null,
        });
    };

    const openDeleteChampionConfirm = (championId) => {
        setDeleteTarget({
            open: true,
            kind: 'champion',
            event: null,
            championId,
        });
    };

    const closeDeleteConfirm = () => {
        if (deleteLoading) return;
        setDeleteTarget({ open: false, kind: null, event: null, championId: null });
    };

    const confirmDelete = async () => {
        setDeleteLoading(true);
        try {
            if (deleteTarget.kind === 'event' && deleteTarget.event) {
                await deleteEvent({ id: deleteTarget.event.id });
                const response = await getClubEvents(id);
                setEvents(response.data.data);
            } else if (deleteTarget.kind === 'champion' && deleteTarget.championId != null) {
                await deleteChampion(deleteTarget.championId);
                await fetchChampions();
            }
            setDeleteTarget({ open: false, kind: null, event: null, championId: null });
        } catch (error) {
            console.error('Failed to delete:', error);
        } finally {
            setDeleteLoading(false);
        }
    };

    const currentDate = new Date();
    const pastEvents = events.filter(event => new Date(event.event_date) < currentDate);
    const futureEvents = events.filter(event => new Date(event.event_date) >= currentDate);

    const handleEventClick = (eventId) => {
        navigate(`/clubs/category/${eventId}`, { 
            state: { 
                videoUrl: events.find(event => event.id === eventId)?.event_video 
            } 
        });
    };

    // Champions handlers
    const handleChampionEdit = (champion) => {
        setEditingChampion(champion);
        setChampionFormData({
            id: champion.id,
            riderid: champion.user_id,
            clubid: id,
            points: champion.points,
            type: champion.type
        });
        setIsChampionModalOpen(true);
    };

    const handleChampionSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingChampion) {
                await updateChampion(championFormData);
            } else {
                await createChampion(championFormData);
            }
            
            await fetchChampions();
            setIsChampionModalOpen(false);
            setEditingChampion(null);
            setChampionFormData({
                riderid: '',
                clubid: id,
                points: '',
                type: ''
            });
        } catch (error) {
            console.error('Failed to save champion:', error);
        }
    };

    const getRiderName = (riderId) => {
        const rider = riders.find(r => r.id === riderId);
        return rider ? rider.name : 'Unknown Rider';
    };

    const deleteDialogMessage =
        deleteTarget.kind === 'event'
            ? 'Are you sure you want to delete this event? This action cannot be undone.'
            : deleteTarget.kind === 'champion'
              ? 'Are you sure you want to remove this champion? This action cannot be undone.'
              : 'This action cannot be undone.';

    return (
        <Box sx={{ p: 3 }}>
            <ConfirmDialog
                open={deleteTarget.open}
                title={deleteTarget.kind === 'champion' ? 'Remove champion' : 'Delete event'}
                message={deleteDialogMessage}
                confirmLabel="Delete"
                onCancel={closeDeleteConfirm}
                onConfirm={confirmDelete}
                loading={deleteLoading}
            />
            {/* Champions Section */}
            {champion_available === 'true' && (
                <>
                    <Typography variant="h6" component="h3" sx={{ mb: 2, mt: 4 }}>
                        Club Champions
                    </Typography>
                    <Box sx={{ mb: 3 }}>
                        <Button
                            variant="contained"
                            startIcon={<TrophyIcon />}
                            onClick={() => setIsChampionModalOpen(true)}
                            sx={{
                                backgroundColor: '#ff9800',
                                borderRadius: '8px',
                                textTransform: 'uppercase',
                                '&:hover': {
                                    backgroundColor: '#f57c00'
                                }
                            }}
                        >
                            Add Champion
                        </Button>
                    </Box>
                    
                    <TableContainer component={Paper} sx={{ mb: 4 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Rider Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Points</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {champions.map((champion) => (
                                    <TableRow key={champion.id}>
                                        <TableCell>{champion.name}</TableCell>
                                        <TableCell sx={{ textTransform: 'capitalize' }}>{champion.type}</TableCell>
                                        <TableCell>{champion.points}</TableCell>
                                        <TableCell>
                                            <Button
                                                size="small"
                                                onClick={() => handleChampionEdit(champion)}
                                                sx={{ mr: 1 }}
                                            >
                                                Edit
                                            </Button>
                                            <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() => openDeleteChampionConfirm(champion.id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {champions.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            <Typography variant="body2" color="text.secondary">
                                                No champions added yet
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            )}

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                    Club Events
                </Typography>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => {
                        setEditingEvent(null);
                        setFormData(getEmptyEventForm());
                        setIsModalOpen(true);
                    }}
                    sx={{
                        backgroundColor: '#1976d2',
                        borderRadius: '8px',
                        textTransform: 'uppercase',
                        '&:hover': {
                            backgroundColor: '#1565c0'
                        }
                    }}
                >
                    Add Event
                </Button>
            </Box>

            <Typography variant="h6" component="h3" sx={{ mb: 2, mt: 4 }}>
                Upcoming Events
            </Typography>
            <MuiGrid container spacing={3}>
                {futureEvents.map((event) => (
                    <MuiGrid item xs={12} sm={6} md={4} lg={3} key={event.id}>
                        <Card 
                            sx={{ 
                                position: 'relative',
                                height: '100%', 
                                display: 'flex', 
                                flexDirection: 'column',
                                cursor: 'pointer',
                                '&:hover': {
                                    boxShadow: 6
                                }
                            }}
                            onClick={() => handleEventClick(event.id)}
                        >
                            <Box sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                zIndex: 1,
                                display: 'flex',
                                gap: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                borderRadius: 1,
                                padding: '4px'
                            }}>
                                <Button
                                    size="small"
                                    onClick={(e) => handleEditClick(event, e)}
                                >
                                    Edit
                                </Button>
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={(e) => openDeleteEventConfirm(event, e)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Box sx={{
                                position: 'absolute',
                                left: 16,
                                top: 16,
                                zIndex: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                borderRadius: '8px',
                                padding: '8px 16px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                    {new Date(event.event_date).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    })}
                                </Typography>
                            </Box>
                            <Box sx={{ position: 'relative', paddingTop: '56.25%' /* 16:9 aspect ratio */ }}>
                                {event.image ? (
                                    <CardMedia
                                        component="img"
                                        image={event.image}
                                        alt={event.event_name}
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                ) : (
                                    <CardMedia
                                        component="video"
                                        src={event.event_video}
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                )}
                            </Box>
                            <CardContent sx={{ 
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                                padding: '16px',
                                backgroundColor: '#fff'
                            }}>
                                <Typography 
                                    variant="h6" 
                                    component="h3"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem',
                                        lineHeight: 1.2,
                                        marginBottom: 1
                                    }}
                                >
                                    {event.event_name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Sessional pass: {getSessionalPassFromEvent(event) ? 'Yes' : 'No'}
                                </Typography>
                            </CardContent>
                        </Card>
                    </MuiGrid>
                ))}
                {futureEvents.length === 0 && (
                    <MuiGrid item xs={12}>
                        <Typography variant="body1" color="text.secondary" align="center">
                            No upcoming events
                        </Typography>
                    </MuiGrid>
                )}
            </MuiGrid>

            <Typography variant="h6" component="h3" sx={{ mb: 2, mt: 4 }}>
                Past Events
            </Typography>
            <MuiGrid container spacing={3}>
                {pastEvents.map((event) => (
                    <MuiGrid item xs={12} sm={6} md={4} lg={3} key={event.id}>
                        <Card 
                            sx={{ 
                                position: 'relative',
                                height: '100%', 
                                display: 'flex', 
                                flexDirection: 'column',
                                cursor: 'pointer',
                                '&:hover': {
                                    boxShadow: 6
                                }
                            }}
                            onClick={() => handleEventClick(event.id)}
                        >
                            <Box sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                zIndex: 1,
                                display: 'flex',
                                gap: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                borderRadius: 1,
                                padding: '4px'
                            }}>
                                <Button
                                    size="small"
                                    onClick={(e) => handleEditClick(event, e)}
                                >
                                    Edit
                                </Button>
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={(e) => openDeleteEventConfirm(event, e)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                            <Box sx={{
                                position: 'absolute',
                                left: 16,
                                top: 16,
                                zIndex: 1,
                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                borderRadius: '8px',
                                padding: '8px 16px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                    {new Date(event.event_date).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    })}
                                </Typography>
                            </Box>
                            <Box sx={{ position: 'relative', paddingTop: '56.25%' /* 16:9 aspect ratio */ }}>
                                {event.image ? (    
                                    <CardMedia
                                        component="img"
                                        image={event.image}
                                        alt={event.event_name}
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                ) : (
                                    <CardMedia
                                        component="video"
                                        src={event.event_video}
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                )}
                            </Box>
                            <CardContent sx={{ 
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                                padding: '16px',
                                backgroundColor: '#fff'
                            }}>
                                <Typography 
                                    variant="h6" 
                                    component="h3"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem',
                                        lineHeight: 1.2,
                                        marginBottom: 1
                                    }}
                                >
                                    {event.event_name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Sessional pass: {getSessionalPassFromEvent(event) ? 'Yes' : 'No'}
                                </Typography>
                            </CardContent>
                        </Card>
                    </MuiGrid>
                ))}
                {pastEvents.length === 0 && (
                    <MuiGrid item xs={12}>
                        <Typography variant="body1" color="text.secondary" align="center">
                            No past events
                        </Typography>
                    </MuiGrid>
                )}
            </MuiGrid>

            <Dialog 
                open={isModalOpen} 
                onClose={() => {
                    setIsModalOpen(false);
                    setEditingEvent(null);
                    setFormData(getEmptyEventForm());
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {editingEvent ? 'Edit Event' : 'Create New Event'}
                </DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                label="Event Name"
                                value={formData.event_name}
                                onChange={(e) => setFormData(prev => ({...prev, event_name: e.target.value}))}
                                fullWidth
                                required
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={parseSessionalPass(formData.as_sessional_pass)}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                as_sessional_pass: e.target.checked
                                            }))
                                        }
                                    />
                                }
                                label="Sessional pass"
                            />
                            <TextField
                                type="date"
                                label="Event Date"
                                value={formData.event_date}
                                onChange={(e) => setFormData(prev => ({...prev, event_date: e.target.value}))}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                type="file"
                                label="Image"
                                onChange={(e) => handleFileUpload(e, 'image')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: 'image/*' }}
                            />
                            <Typography variant="subtitle2" color="text.secondary">
                                Add video by uploading or entering URL
                            </Typography>
                            
                            <TextField
                                type="file"
                                label="Upload Video"
                                onChange={(e) => handleFileUpload(e, 'event_video')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: 'video/*' }}
                            />
                            
                            <TextField
                                label="Or Enter Video URL"
                                value={formData.event_video_url}
                                onChange={(e) => setFormData(prev => ({...prev, event_video_url: e.target.value}))}
                                fullWidth
                                placeholder="https://..."
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            type="button"
                            onClick={() => {
                                setIsModalOpen(false);
                                setEditingEvent(null);
                                setFormData(getEmptyEventForm());
                            }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type="submit"
                            variant="contained"
                            disabled={isUploading}
                        >
                            {isUploading ? 'Uploading...' : editingEvent ? 'Update Event' : 'Create Event'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {/* Champions Modal */}
            <Dialog 
                open={isChampionModalOpen} 
                onClose={() => setIsChampionModalOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {editingChampion ? 'Edit Champion' : 'Add New Champion'}
                </DialogTitle>
                <form onSubmit={handleChampionSubmit}>
                    <DialogContent>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <FormControl fullWidth>
                                <InputLabel>Rider</InputLabel>
                                <Select
                                    value={championFormData.riderid}
                                    onChange={(e) => setChampionFormData(prev => ({...prev, riderid: e.target.value}))}
                                    label="Rider"
                                    required
                                >
                                    {riders.map((rider) => (
                                        <MenuItem key={rider.id} value={rider.id}>
                                            {rider.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                type="number"
                                label="Points"
                                value={championFormData.points}
                                onChange={(e) => setChampionFormData(prev => ({...prev, points: e.target.value}))}
                                fullWidth
                                required
                                inputProps={{ min: 0 }}
                            />
                            <FormControl fullWidth>
                                <InputLabel>Type</InputLabel>
                                <Select
                                    value={championFormData.type}
                                    onChange={(e) => setChampionFormData(prev => ({...prev, type: e.target.value}))}
                                    label="Type"
                                    required
                                >
                                    <MenuItem value="junior">Junior</MenuItem>
                                    <MenuItem value="senior">Senior</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setIsChampionModalOpen(false)}>
                            Cancel
                        </Button>
                        <Button 
                            type="submit"
                            variant="contained"
                        >
                            {editingChampion ? 'Update Champion' : 'Add Champion'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Box>
    );
};

export default ClubDetails;